import React from "react";
import "../styles/OurCampus.css";
import Footer from "../components/Home/Footer";

const OurCampus = () => {
  return (
    <>
      <div className="our-campus">
        <h2>Our Campus</h2>
        <div className="image-grid">
          <div className="image-item">
            <img
              src="https://i.ytimg.com/vi/NtfvEcByA54/hqdefault.jpg"
              alt="Image1"
            />
          </div>
          <div className="image-item">
            <img
              src="https://i.ytimg.com/vi/NtfvEcByA54/hqdefault.jpg"
              alt="Image2"
            />
          </div>
          <div className="image-item">
            <img
              src="https://i.ytimg.com/vi/NtfvEcByA54/hqdefault.jpg"
              alt="Image3"
            />
          </div>
          <div className="image-item">
            <img
              src="https://i.ytimg.com/vi/NtfvEcByA54/hqdefault.jpg"
              alt="Image4"
            />
          </div>
          <div className="image-item">
            <img
              src="https://i.ytimg.com/vi/NtfvEcByA54/hqdefault.jpg"
              alt="Image5"
            />
          </div>
          <div className="image-item">
            <img
              src="https://i.ytimg.com/vi/NtfvEcByA54/hqdefault.jpg"
              alt="Image6"
            />
          </div>
          <div className="image-item">
            <img
              src="https://i.ytimg.com/vi/NtfvEcByA54/hqdefault.jpg"
              alt="Image7"
            />
          </div>
          <div className="image-item">
            <img
              src="https://i.ytimg.com/vi/NtfvEcByA54/hqdefault.jpg"
              alt="Image8"
            />
          </div>
          <div className="image-item">
            <img
              src="https://i.ytimg.com/vi/NtfvEcByA54/hqdefault.jpg"
              alt="Image9"
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OurCampus;
